import { useEffect, useState } from "react";
import MandatorySign from "../../../Components/MandatorySign";

const InputManual = ({
    handleClose,
    handleSelect,
    selectedItem,
    selectedNode
}) => {
    const [customName, setCustomName] = useState("")
    const [errorMessage, setErrorMessage] = useState({
        message: "",
        display: false
    });

    const handleConfirm = () => {
        if (!customName.trim()) {
            setErrorMessage({ message: "Custom name is required", display: true });
            return;
        }

        handleSelect(selectedItem.value, selectedItem, {
            custom_name: customName
        });
    };

    useEffect(() => {
        if (!selectedNode) return;

        const existing = selectedNode?.data?.params?.custom_name;

        if (existing) {
            setCustomName(existing)
        }
    }, [selectedNode]);

    return (
        <>
            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="modal_profile_input_cont">
                        <div className="label_input">
                            <label className="input_label">
                                Custom name <MandatorySign message="Custom name is required" />
                            </label>

                            <input
                                type="text"
                                className="register_form_first fade-in"
                                value={customName}
                                placeholder="Manual trigger"
                                onChange={(e) => setCustomName(e.target.value)}
                            />
                        </div>
                        <p className="role_warning_text">
                            {selectedItem?.description}
                        </p>
                    </div>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleConfirm}
                    >
                        Confirm
                    </button>
                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </>

    );
};

export default InputManual;